import { Building2, Building, Users, Landmark, Rocket, Hammer, Briefcase, BookOpen } from "lucide-react";
import { Reveal, Eyebrow } from "./Reveal";
import { SectionMedia } from "./SectionMedia";
import { useApp } from "../store";

const ICONS = [Building2, Building, Users, Landmark, Rocket, Hammer, Briefcase, BookOpen];

export const Clients = () => {
  const { c, t } = useApp();

  return (
    <section id="clients" data-testid="clients-section" className="relative text-white grain" style={{ background: "var(--sec-clients-bg, #0A1428)" }}>
      <div className="max-w-7xl mx-auto px-5 sm:px-8 py-24 sm:py-32 relative z-10">
        <Reveal className="flex flex-wrap items-end justify-between gap-6 mb-14">
          <div>
            <Eyebrow light>{t("clients_eyebrow")}</Eyebrow>
            <h2 data-testid="clients-title" className="mt-5 font-display font-semibold text-2xl sm:text-3xl lg:text-4xl tracking-tight">
              {t("clients_title")}
            </h2>
          </div>
          <p className="max-w-sm text-sm sm:text-base text-white/60 leading-relaxed">{t("clients_sub")}</p>
        </Reveal>

        <div className="grid grid-cols-2 lg:grid-cols-4 gap-px bg-[var(--accent-soft)]/10 border border-[var(--accent-soft)]/10">
          {ICONS.map((Icon, i) => (
            <Reveal key={i} delay={i * 0.05}>
              <article
                data-testid={`client-card-${i + 1}`}
                className="group h-full bg-[#101E3D] hover:bg-[#12254D] p-6 sm:p-8 transition-colors duration-500"
              >
                <Icon
                  size={26}
                  strokeWidth={1.5}
                  className="text-[var(--accent-soft)] transition-transform duration-500 group-hover:-translate-y-1"
                />
                <h3 className="mt-5 font-display font-semibold text-lg sm:text-xl leading-snug group-hover:text-white transition-colors duration-500">
                  {c(`client_${i + 1}_title`)}
                </h3>
                <p className="mt-2 text-xs sm:text-sm text-white/60 group-hover:text-white/60 leading-relaxed transition-colors duration-500">
                  {c(`client_${i + 1}_desc`)}
                </p>
              </article>
            </Reveal>
          ))}
        </div>

        <SectionMedia section="clients" light />
      </div>
    </section>
  );
};
